import axios from '@axios'

export default {
  namespaced: true,
  state: {
    user: null,
    authorization: null,
    permissions: null,
  },
  getters: {
    getUser(state) {
      return state.user
    },
    getAuthorization(state) {
      return state.authorization
    },
    getPermissions(state) {
      return state.permissions
    },

  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setAuthorization(state, authorization) {
      state.authorization = authorization
    },
    setPermissions(state, permissions) {
      state.permissions = permissions
    },
  },

  actions: {

    login(context, login) {
      return axios.post('login', login, { headers: { callbackerror: true } })
    },
    logout(context) {
      return axios.post('logout', { headers: { callbackerror: true } })
    },

    // update(context, role) {
    //   return axios.put(`${route}/${role.id}`, role)
    // },
    // delete(context, role) {
    //   return axios.delete(`${route}/${role.id}`)
    // },
  },
}
